import { action } from "typesafe-actions";
import { VIPCircleActionTypes } from "./vipcircle.model";

export const createVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.CREATE_VIP_CIRCLE_REQUEST, req);
export const createVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.CREATE_VIP_CIRCLE_SUCCESS, res);
export const createVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.CREATE_VIP_CIRCLE_FAILURE, err);

export const updateVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.UPDATE_VIP_CIRCLE_REQUEST, req);
export const updateVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.UPDATE_VIP_CIRCLE_SUCCESS, res);
export const updateVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.UPDATE_VIP_CIRCLE_FAILURE, err);

export const cancelVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.CANCEL_VIP_CIRCLE_REQUEST, req);
export const cancelVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.CANCEL_VIP_CIRCLE_SUCCESS, res);
export const cancelVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.CANCEL_VIP_CIRCLE_FAILURE, err);

export const getVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.FETCH_VIP_CIRCLE_REQUEST, req);
export const getVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.FETCH_VIP_CIRCLE_SUCCESS, res);
export const getVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.FETCH_VIP_CIRCLE_FAILURE, err);

export const getOtherVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_REQUEST, req);
export const getOtherVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_SUCCESS, res);
export const getOtherVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.FETCH_OTHER_VIP_CIRCLE_FAILURE, err);

export const sendVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.SEND_VIP_CIRCLE_REQUEST, req);
export const sendVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.SEND_VIP_CIRCLE_SUCCESS, res);
export const sendVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.SEND_VIP_CIRCLE_FAILURE, err);

export const upsertVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.UPSERT_VIP_CIRCLE_REQUEST, req);
export const upsertVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.UPSERT_VIP_CIRCLE_SUCCESS, res);
export const upsertVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.UPSERT_VIP_CIRCLE_FAILURE, err);

export const deleteVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.DELETE_VIP_CIRCLE_REQUEST, req);
export const deleteVIPCircleSuccess = (res) =>
    action(VIPCircleActionTypes.DELETE_VIP_CIRCLE_SUCCESS, res);
export const deleteVIPCircleFailure = (err) =>
    action(VIPCircleActionTypes.DELETE_VIP_CIRCLE_FAILURE, err);

export const getVIPSubscriptionRequest = (req) =>
    action(VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_REQUEST, req);
export const getVIPSubscriptionSuccess = (res) =>
    action(VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_SUCCESS, res);
export const getVIPSubscriptionFailure = (err) =>
    action(VIPCircleActionTypes.FETCH_VIP_SUBSCRIPTION_FAILURE, err);

export const editVIPCircleRequest = (req) =>
    action(VIPCircleActionTypes.EDIT_VIP_CIRCLE_REQUEST, req);
